import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants/messages';
import { ErrorFallback } from '@/shared/ui/ErrorBoundary';

import { DagListSummary, DagTableContent } from '@/features/dag-list';

import styles from './DagListPage.module.css';

const DASHBOARD_CARD_HEIGHT = 108;

const renderDashboardErrorFallback = (fallbackProps: FallbackProps) => (
  <ErrorFallback
    className={styles.dashboardErrorFallback}
    variant="compact"
    height={DASHBOARD_CARD_HEIGHT}
    {...fallbackProps}
  />
);

const renderListErrorFallback = (fallbackProps: FallbackProps) => (
  <ErrorFallback className={styles.listErrorFallback} title={NOTIFICATION_MESSAGES.DAG_LIST_ERROR} {...fallbackProps} />
);

export const DagListPage = () => {
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <h1 className={styles.title}>Dashboard</h1>
        </div>
      </div>

      <div className={styles.dashboardSlot}>
        <ErrorBoundary fallbackRender={renderDashboardErrorFallback}>
          <DagListSummary />
        </ErrorBoundary>
      </div>

      <div className={styles.listCard}>
        <div className={styles.listSlot}>
          <ErrorBoundary fallbackRender={renderListErrorFallback}>
            <div className={styles.listContent}>
              <DagTableContent />
            </div>
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};
